import {useState} from "react";
import './vacancyCard.scss';
import {MoreBtnIcon} from "../../../../assets/images";
import VacancyApplyModal from "../../../../components/uiElements/modals/vacancyApplyModal/VacancyApplyModal";
import {Link, useNavigate} from "react-router-dom";
import {GetUrlWithLocal} from "../../../../utils/getUrlWithLocal";


export default function VacancyCard(props) {
    const {vacancy, translations} = props

    return <Link to={GetUrlWithLocal(`/vacancy/${vacancy?.slug}`)} className='vacancyCard'>
        <div className={'top_block'}>
            <div className={'info_title'}>
                {vacancy?.title}
            </div>
            <pre className={'info_description'}>
                {vacancy?.description}
            </pre>
        </div>

        <div className={'bottom_block'}>
            <div className={'salary'}>
                {vacancy?.salary && <>
                    {translations?.vacancy_salary_from}
                    <span>{vacancy?.salary}</span>
                    {translations?.vacancy_salary_currency}
                </>}
            </div>
            <div className={'more-btn'}>
                {translations?.vacancy_more_btn} <MoreBtnIcon/>
            </div>
        </div>
        {/*{vacancyModalOpen && <VacancyApplyModal visible={vacancyModalOpen}*/}
        {/*                                        vacancyId={vacancy.id}*/}
        {/*                                        vacancyCV={vacancy?.cvIsRequired}*/}
        {/*                                 closeModal={closeVacancyModal}/>}*/}
    </Link>
}